import { hasData } from '@/utils/tools/hasData';
/**
 * opCompatibility
 */
//商品图
export function detail_images({
  goods_info = {},
  img_details = {},
  goods_gellery_imgs
}) {
  let images = [];
  if (goods_gellery_imgs) return goods_gellery_imgs;
  if (img_details.detail_images) {
    img_details.detail_images.forEach(item => {
      images.push({
        goods_id: goods_info.goods_id,
        img_url: item,
        path: item
      });
    });
  }

  return images;
}
// 商品详情 字段映射
export const goodDetailsResponse = res => {
  const { goods_info = {} } = res || {};
  const keys = Object.keys(goods_info);
  keys.forEach(key => {
    res[key] = goods_info[key];
    if (key === 'spu_id') {
      res.goods_id = goods_info[key];
    }
  });

  res.goods_gellery_imgs = detailsImgList(res, 'gallery');
  res.goods_desc_imgs = detailsImgList(res, 'detail_images');
  return res;
};
function detailsImgList(res = {}, key = '') {
  // 安全取值：res.img_details?.[key] 需可选链，降级用传统写法
  const imgList = (res.img_details && res.img_details[key]) || [];

  // 仅当 imgList 为数组时处理，否则返回空数组
  if (!Array.isArray(imgList)) {
    return [];
  }

  // 映射并确保每个元素都是有效的 URL 字符串
  return imgList.map(item => ({
    goods_id: res.goods_id,
    img_url: typeof item === 'string' ? item : '',
    path: typeof item === 'string' ? item : ''
  }));
}
// 品牌详情 返参处理（移植 mall_h5 lib/optimize/compatibility 的 BrandDetailsResponse）
export function brandDetailsResponse(res) {
  const { brand_details = {} } = res || {};
  return {
    ...res,
    info: brand_details,
    ...brand_details
  };
}
const changeObjKey = (data, oldKey, newKey) => {
  if (data.hasOwnProperty(oldKey)) {
    data[newKey] = data[oldKey];
    delete data[oldKey];
  }
};
// 商品搜索 请求参数统一（移植 mall_h5 lib/optimize/compatibility 的 goodSearchParams）
export function goodSearchParams(params = {}) {
  const newParams = JSON.parse(JSON.stringify(params || {}));
  if (!newParams.page_size) {
    newParams.page_size = 20;
  }
  if (!newParams.with_facets) {
    newParams.with_facets = 1;
  }
  changeObjKey(newParams, 'cat_parent_id', 'category_parent_id');
  changeObjKey(newParams, 'cat_id', 'category_id');
  changeObjKey(newParams, 'is_same_send', 'delivery_type');
  changeObjKey(newParams, 'is_use_delivery', 'delivery_type');
  if (Number(newParams.delivery_type)) {
    newParams.delivery_type = Number(newParams.delivery_type);
  }
  changeObjKey(newParams, 'brand_ids', 'brand_id');
  changeObjKey(newParams, 'order', 'sort_order');
  changeObjKey(newParams, 'keywords', 'keyword');
  changeObjKey(newParams, 'sort', 'sort_by');
  if (newParams.sort_by) {
    newParams.sort_by = newParams.sort_by == 'sales' ? 'sales' : 'price';
  }
  return newParams;
}
// 商品搜索 字段映射
export const goodSearchResponse = res => {
  const result = JSON.parse(JSON.stringify(res));

  const { filter = {}, list = [] } = result || {};
  if (hasData(filter)) {
    let { brand_filter, category_filter } = filter || {};
    result.filter.brand_list = brand_filter;
    if (category_filter && category_filter.length) {
      category_filter = category_filter.map(item => {
        const { id, cate_name } = item;
        return { cat_id: id, cat_name: cate_name };
      });
    }
    result.filter.cate_list = category_filter;
    delete result.filter.brand_filter;
    delete result.filter.category_filter;
  }
  if (hasData(list)) {
    list.forEach(item => {
      /**
       * is_free_shipping ：值为数字1时  显示文字‘一件包邮’
       * coupons与act_info：  存在则显示，优惠券
       * desc_code：存在时候不显示价格，显示熊猫码desc_code的内容（灰色）
       * */
      item.is_show_goods_price = Number(item.shop_price);
      // 优化icon为不显示，新功能调整为了tags
      goodsIconOut(item);
    });
    result.items = list;
    delete result.list;
  }
  result.lastPage = result.total_page;
  result.totalPage = result.total_page;
  result.page_size = 20;
  result.page = result.current_page;
  delete result.total_page;
  delete result.current_page;
  return result;
};
// 商品搜索 去除商品tag
function goodsIconOut(item) {
  delete item.is_third;
  delete item.left_icon;
  delete item.goods_style;
  delete item.is_hot;
  delete item.is_new;
  delete item.is_shipping;
  delete item.is_presale;
  delete item.is_use_delivery;
  // 生日专场
  delete item.choosed;
}
/** 商品规格 字段映射 */
export const skuInfoResponse = res => {
  let data = transformSpecifications(res);
  if (data) {
    if (data.spec && data.spec.length) {
      data.spec = data.spec.map((item, index) => {
        item._item = item._item.map((_item, _index) => {
          return {
            ..._item,
            stem_value_id: _index + 1
          };
        });
        item.spec_id = index + 1;
        return item;
      });
    }
    if (data.skus && data.skus.length) {
      data.skus = data.skus.map(item => {
        if (data.spec && data.spec.length) {
          item.spc_items = item.spc_items.map(i => {
            let spec = data.spec.find(a => a.spec_name == i.spec_name);
            if (!spec) return i;
            let specItem = spec._item.find(
              a => a.spec_value_name == i.spec_value_name
            );
            if (!specItem) return i;
            return {
              ...i,
              spec_id: spec.spec_id || 0,
              spec_value_id: specItem.stem_value_id || 0
            };
          });
        }
        return item;
      });
    }
  }
  return data;
};

/**转换规格字符串为数组 */
const transformSpecifications = (data, specKey = 'skus') => {
  const specifications = data[specKey];
  const specMap = new Map();
  const skus = [];

  for (const item of specifications) {
    const specItems = parseSpecString(item.spec);

    if (!specItems || !specItems.length) {
      // 商品没有规格，直接返回
      skus.push({ ...item, spc_items: [] });
      continue;
    }
    for (const { spec_name, spec_value_name } of specItems) {
      if (!specMap.has(spec_name)) {
        specMap.set(spec_name, new Set());
      }
      specMap.get(spec_name).add(spec_value_name);
    }

    const restData = JSON.parse(JSON.stringify(item));
    delete restData.spec;
    skus.push({ ...restData, spc_items: specItems });
  }

  return {
    spec: Array.from(specMap, ([spec_name, valueSet]) => ({
      spec_name,
      _item: Array.from(valueSet, spec_value_name => ({ spec_value_name }))
    })),
    skus
  };
};
const parseSpecString = specStr => {
  if (!specStr) return [];
  if (!specStr.includes(':') && !specStr.includes(';')) {
    return [{ spec_name: '规格', spec_value_name: specStr }];
  }

  return specStr
    .split(';')
    .map(s => s.trim())
    .filter(Boolean)
    .map(part => {
      const [spec_name, spec_value_name] = part.split(':');
      return spec_name && spec_value_name
        ? {
            spec_name: spec_name.trim(),
            spec_value_name: spec_value_name.trim()
          }
        : null;
    })
    .filter(Boolean);
};
